export enum PaymentType {
  DEPOSIT = 'DEPOSIT',
  PREPAYMENT = 'PREPAYMENT'
}

export enum PaymentStrategyType {
  PARTYSIZE = 'PARTYSIZE',
  BOOKING = 'BOOKING'
}

export interface StrategyResponse {
  type: PaymentStrategyType
  paymentAmount: number
  strategyAmount: number
}

export interface PaymentConfigSnapshotResponse {
  guid: string
  name: string
  type: PaymentType
  policy?: string | null
  cancellationRefundableTimeframe: number
  strategy: StrategyResponse
}
